import * as React from 'react'
import { cn } from '@/lib/utils'
import { BrandLogo } from './BrandLogo'

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>

function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-muted',
        className
      )}
      {...props}
      aria-hidden="true"
    />
  )
}

export type SkeletonLayoutProps = React.HTMLAttributes<HTMLDivElement> & {
  label?: string
}

function BrandLoadingProgress() {
  return (
    <div className="samadhi-loader" aria-hidden="true" data-testid="brand-loading-progress">
      <span className="samadhi-loader__medallion">
        <BrandLogo className="samadhi-loader__logo" />
      </span>
    </div>
  )
}

/**
 * Reserves the final content geometry while a dynamic surface is loading.
 * Keep the skeleton decorative and expose one concise loading announcement.
 */
function SkeletonLayout({ label = 'Loading', className, children, ...props }: SkeletonLayoutProps) {
  return (
    <div
      {...props}
      role="status"
      className={cn(className)}
      aria-busy="true"
    >
      <span className="sr-only">{label}</span>
      <BrandLoadingProgress />
      {children}
    </div>
  )
}

export { BrandLoadingProgress, Skeleton, SkeletonLayout }
